export default {
  methods: {
    //値が「null」「''」「undefined」かどうか判定する
    isNullOrEmpty(value) {
      return value == null || value === "";
    },
    // 半角スペース → 全角スペース
    // 連続スペース → 全角スペース1つにまとめる 
    normalizeSpace(value) {
     if (typeof value !== "string") {
        return value; 
       } 
      // 半角スペースを全角スペースへ
       let result = value.replace(/ /g, "　"); 
      // 全角スペースが連続している場合は1つにまとめる
       result = result.replace(/　+/g, "　");
       return result;
    },
    // 両方が空なら差分なし。どちらかに値があり、かつ値が違えば差分あり。
    isDiff(a, b) {
      const na = this.normalizeSpace(a);
      const nb = this.normalizeSpace(b);
      return !(this.isNullOrEmpty(a) && this.isNullOrEmpty(b)) && na !== nb;
    }
  }
};

